import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import WorkflowListItem from '@workflow/components/List/WorkflowListItem.vue'
import DrafterViewModal from '@workflow/components/Modals/DrafterViewModal.vue'
import { createEventBus, removeEventBus, uGetDate, uGetDateFormat } from '@/util'
import api from '@workflow/api'
import { mapGetters } from 'vuex'
import * as accountTypes from '@account/store/types'
@Component({
    components: { WorkflowListItem, DrafterViewModal },
    computed: {
        ...mapGetters({
            User: accountTypes.USER
        })
    }
})
export default class ListContainer extends Vue {

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    User!: account.User

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    pageNumber: number = 1
    itemsPerPage: number = 10
    loadMorePossible: boolean = true
    searchValue: workflow.EnumSearchType | null = null
    workflowList: Array<workflow.WorkflowItem> = []
    showDrafterModal: boolean = false
    drafterInfo: Object | null = null
    documentPages: Array<workflow.TC_DOCUMENT_PAGES> = []

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M P U T E D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    /**
     * 전자결재 문서 총 개수
     */
    get totalCount(): Number {
        let count = 0;
        if (this.workflowList && this.workflowList.length)
            count = this.workflowList[0].totalCount;
        return count;
    }

    get pageItem() {
        var item = this.documentPages?.filter((x) => x.no == Number(this.$route.query.id))[0]
        if (item) {
            return item
        }
        return null
    }

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    setDrafter(newVal: any) {
        this.drafterInfo = newVal
        this.showDrafterModal = true
    }

    loadData() {
        var requestDocument: workflow.RequestDocument = {
            documentQueryNumber: Number(this.$route.query.id),
            personCode: this.User.personCode,
            deptCode: this.User.deptCode,
            apmStatus: null,
            applicationId: null,
            startDate: uGetDateFormat('yyyy-MM-DD' ,uGetDate(-1, new Date(), 'year')),
            endDate: uGetDateFormat('yyyy-MM-DD', new Date()),
            searchType: this.searchValue ? 1 : -1,
            searchValue: this.searchValue,
            itemsPerPage: this.itemsPerPage,
            page: this.pageNumber,
            sortValue: this.pageItem?.searchSortValue || 4,
        }
        console.log(requestDocument)
         //추가 페이지 여부 확인 2023-05-30
         if(this.totalCount > 0){
            if (this.pageNumber > Math.ceil(Number(this.totalCount)/this.itemsPerPage))
            {
                this.loadMorePossible = false
                return false
            }
        }

        api.document.getDocumentList(requestDocument).then((res) => {
            if (res.length) {
                if (this.pageNumber > 1) {
                    this.workflowList = [...(this.workflowList || []), ...res]
                } else {
                    this.isloading(false)
                    this.workflowList = res
                }
            } else {
                this.isloading(false)
                this.loadMorePossible = false
            }
            this.isloading(false)
        })
    }

    loadMore() {
        if (this.loadMorePossible) {
            this.pageNumber ++
            this.loadData()
        }
    }

    loadDataReset() {
        this.workflowList = []
        this.pageNumber = 1
        this.loadMorePossible = true
    }

    getDocumentPages() {
        api.common.getDocumentPages().then((res: any) => {
            this.documentPages = res
        }).then(() => this.loadData())
    }

    handleSearchRequest(keyword: any) {
        if (keyword) {
            this.searchValue = keyword
        } else {
            this.searchValue = null
            this.$emit('searchEnd')
        }
        this.loadDataReset()
        this.loadData()
    }

    @Watch('$route.query.id')
    onChangedDocumentId() {
        this.loadDataReset()
        this.loadData()
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        this.isloading(true)
        this.getDocumentPages()

        createEventBus(window, 'header-search', this.handleSearchRequest)
    }

    beforeDestroy() {
        removeEventBus(window, 'header-search', this.handleSearchRequest)
    }
}
